import { useMemo } from 'react';
import { COMPANY_NAME } from 'src/constants/Defaultvalues';

function useCompanyProfile() {
    const userData = JSON.parse(localStorage.getItem('user'));
    const workSpaceTitle = useMemo(() => ({
        COMPANY_LOGO: userData?.company_logo,
        COMPANY_NAME: userData?.company_name||COMPANY_NAME||'Signwise Solutions', //'Signwise Solutions Arizona'
        companyAddressLine1:userData?.company_address_line1||'680 COLUMBIA AVENUE',
        companyAddressLine2: userData?.company_address_line2||'RIVERSIDE , CA, 92507',
        companyTelephone:userData?.company_telephone||'+1526656565665'
    }), [userData]);

    return workSpaceTitle;
}

export default useCompanyProfile;
